function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "incorrect");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "radio-/-incorrect"
}, /*#__PURE__*/React.createElement("g", {
  id: "incorrect"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-4",
  fill: "#D50037",
  cx: 16,
  cy: 16,
  r: 16
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2133173,21.7108261 L15.9999866,17.9234359 L19.7869992,21.7104828 C20.0060386,21.9294879 20.3614455,21.9294879 20.5808282,21.7104828 L21.4607966,20.8305144 C21.6798017,20.611475 21.6798017,20.2560681 21.4607966,20.0366854 L17.6734064,16.2500161 L21.4604533,12.4630035 C21.6794584,12.2439641 21.6794584,11.8885572 21.4604533,11.6691745 L20.5804849,10.7892061 C20.3614455,10.570201 20.0060386,10.570201 19.7866559,10.7892061 L15.9999866,14.5765963 L12.212974,10.7895494 C11.9939346,10.5705443 11.6385277,10.5705443 11.419145,10.7895494 L10.5395199,11.6691745 C10.3205148,11.8881796 10.3205148,12.2436208 10.5395199,12.4630035 L14.3265668,16.2500161 L10.5395199,20.0370287 C10.3205148,20.2560681 10.3205148,20.611475 10.5395199,20.8308577 L11.4194883,21.7108261 C11.6385277,21.9298312 11.9939346,21.9298312 12.2133173,21.7108261 Z",
  id: "t",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}))));

var SvgIncorrect = function SvgIncorrect(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIncorrect, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/incorrect.32ab225a.svg";
export { ForwardRef as ReactComponent };